// extracted by mini-css-extract-plugin
export default {"editMsg":"KitControls_editMsg__wljLw"};